import { defineStore } from "pinia";
export const useLoaderStore = defineStore("LoaderStore", {
  state: () => {
    return {
      isLoading: false
    }
  },
  actions: {
    open(): void {
      this.isLoading = true
    },
    close(): void {
      this.isLoading = false
    }
  },
  getters: {
    status(): boolean {
      return this.isLoading
    }
  }
});






